import { ModalProps, Modal as _Modal } from 'antd';

import { getClassName } from '../_utils';

import './Modal.scss';

type Props = Pick<
  ModalProps,
  | 'centered'
  | 'cancelButtonProps'
  | 'cancelText'
  | 'children'
  | 'className'
  | 'closable'
  | 'confirmLoading'
  | 'destroyOnHidden'
  | 'footer'
  | 'onCancel'
  | 'onOk'
  | 'okButtonProps'
  | 'okText'
  | 'open'
  | 'title'
  | 'width'
  | 'wrapClassName'
>;

export function Modal({ className, ...props }: Props) {
  return (
    <_Modal
      {...props}
      className={getClassName('modal', className)}
      maskClosable={false}
    />
  );
}
